// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import { ICertificationWebpageFinalFinishAttrs } from 'interfaces/webpage/certification/registration/final/final-view.interface'

const useCertificationFinal = () => {
  // Hook
  const {
    certificationWebpageFinal: { certificationWebpageFinal_loading, certificationWebpageFinal_finish: finish },
  } = useStores()

  /**
   * @description Finish certification final
   *
   * @param {ICertificationWebpageFinalFinishAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpageFinal_finish = useCallback(
    (payload: ICertificationWebpageFinalFinishAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        finish({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [finish],
  )

  return {
    certificationWebpageFinal_loading,
    certificationWebpageFinal_finish,
  }
}

export { useCertificationFinal }
